import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import Barcode from "react-barcode";
export default class PrintBarcodes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      data: [],
      count: 10,

      modal_print: false,
      product_code: "",
      product_name: "",
      product_serial: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count;
    loading(true);
    let [result] = await Promise.all([
      GET("admin/setting/spare-parts/list", {
        page: page,
        data_search: this.state.filter_search,
      }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    this.setState({
      data,
      count,
    });
    loading(false);
  };
  render() {
    const {
      filter_search,
      data,
      count,
      product_code,
      product_name,
      product_serial,
      modal_print,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">พิมพ์บาร์โค้ด</h4>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 mb-2 banks.create"
                  onClick={async () => {
                    this.setState({
                      modal_print: true,
                      product_code: "",
                      product_name: "",
                      product_serial: "",
                    });
                  }}
                >
                  พิมพ์บาร์โค้ด
                </button>
                <button
                  className="btn btn-dark px-3 ms-2 mb-2 banks.create"
                  onClick={async () => {}}
                >
                  พิมพ์บาร์โค้ดทั้งหมด
                </button>
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">ชื่อสินค้า</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_name || "-"}
                      </td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="banks.update"
                            type="print"
                            onClick={() => {
                              window.open(`/pdf/barcode?uid=${item.uid}`);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        <Modal
          show={modal_print}
          onHide={() => this.setState({ modal_print: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">พิมพ์บาร์โค้ด</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div>
              <div className="text-center my-5">
                <div
                  style={{
                    height: 60,
                    overflow: "hidden",
                    marginTop: 30,
                  }}
                >
                  <Barcode value={product_code.replaceAll(" ","")} width={1.5} />
                </div>
                {/* <h1 className="barcode" style={{fontSize:92, transform: "scaleY(2)",display: "inline-block",height:96}}>*{product_code}*</h1> */}
                <div
                  className="d-flex justify-content-center"
                  style={{ height: 26 }}
                >
                  <h4 className="mx-1">{product_code}</h4>
                  <h4 className="mx-1">{product_name}</h4>
                </div>
                <h4 className="mx-1">{product_serial}</h4>
              </div>
            </div>
            <div className="mb-3">
              <div className="mt-2">รหัสสินค้า</div>
              <input
                type="text"
                className="form-control"
                placeholder="รหัสสินค้า..."
                onChange={(e) => {
                  this.setState({ product_code: e.target.value });
                }}
                value={product_code}
              />
            </div>
            <div className="mb-3">
              <div className="mt-2">ชื่อสินค้า</div>
              <input
                type="text"
                className="form-control"
                placeholder="ชื่อสินค้า..."
                onChange={(e) => {
                  this.setState({ product_name: e.target.value });
                }}
                value={product_name}
              />
            </div>
            <div className="mb-3">
              <div className="mt-2">Serial Number</div>
              <input
                type="text"
                className="form-control"
                placeholder="Serial Number..."
                onChange={(e) => {
                  this.setState({ product_serial: e.target.value });
                }}
                value={product_serial}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  window.open(
                    `/pdf/barcode?uid=&product_code=${product_code}&product_name=${product_name.replaceAll("#","@")}&serial_number=${product_serial}`
                  );
                }}
              >
                พิมพ์
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_print: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
